<mat-form-field class="fuse-mat-no-subscript w-full">
    <mat-label>{{field.templateOptions.label}}</mat-label>
    <input [formControl]="control" matInput autocomplete="off" [imask]="getInputMaskForTime()" unmask="typed"
      [placeholder]="field.templateOptions.placeholder">
    <ngx-material-timepicker-toggle class="mat-button mat-icon-button" matSuffix
      [for]="timePicker"></ngx-material-timepicker-toggle>
    <ngx-material-timepicker [format]="24" [defaultTime]="selectedTime" (timeSet)="timeSet($event)" #timePicker></ngx-material-timepicker>
</mat-form-field>